<template>
  <div class="actions">
    <a-popconfirm
      okText="Перезапустить"
      cancelText="Отмена"
      title="Подтвердите перезапуск"
      @confirm="$emit('clickRestart', data)"
      :disabled="Boolean(data.status==='running') || Boolean(disabled) || Boolean(data.disabled)"
    >
      <icon-restart :class="['actions__icon', {'disabled':data.status==='running' || data.any_running || Boolean(disabled) || Boolean(data.disabled)}]" />
    </a-popconfirm>
    <a-popconfirm
      okText="Остановить"
      cancelText="Отмена"
      title="Подтвердите остановку"
      @confirm="$emit('clickStop', data)"
      :disabled="Boolean(data.status!=='running')"
    >
      <a-icon class="question-circle-o__icon" slot="icon" type="question-circle-o" />
      <icon-stop :class="['actions__icon', {'disabled':data.status!=='running'}]" />
    </a-popconfirm>
  </div>
</template>

<script>
export default {
  name: 'ComponentColumnActions',

  components: {
    IconRestart: () => import('@/assets/svg/icon-restart.svg'),
    IconStop: () => import('@/assets/svg/icon-stop.svg'),
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: [Boolean, String],
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  overflow: hidden;
  &__icon {
    width: 40%;
    max-width: 25px;
    height: 40%;
    max-height: 25px;
    cursor: pointer;

    &.disabled {
      opacity: 0.4;
    }

    &:last-child {
      margin-left: 5px;
    }
  }
  .question-circle-o__icon {
    color: $baseColor;
  }
}
</style>
